import request from "@/utils/request";

// 文字转语音
export const text2Audio = (data) => {
  return request({
    url: "/small/voiceCache/text2Audio",
    method: "post",
    data,
  });
};
